const STORAGE_KEY = 'carmenta_promo_box_closed';

function isClosed() {
    try {
        return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
        return false;
    }
}

function markClosed() {
    try {
        sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
}

export function initPromoBox() {
    const box = document.querySelector('[data-promo-box]');
    if (!box) return;

    if (isClosed()) {
        box.remove();
        return;
    }

    box.classList.add('is-visible');

    box.querySelector('[data-promo-close]')?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        markClosed();
        box.classList.remove('is-visible');
        box.classList.add('is-hidden');
    });
}
